import React from "react";
import "../styles/footer.css";
import { FaFacebook, FaTwitter, FaInstagram, FaYoutube } from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="footer_wrapper">
      <div className="container">
        <div className="row">
          <div className="col-lg-5 footer_logo mb-4 mb-lg-0">
            {/* <img
              src={logo}
              alt="Classic Motors KE - Trusted Car Dealer in Mombasa"
              className="footer-logo-img"
              width="150"
              height="auto"
              loading="lazy"
            /> */}
            <h1 className="footer-brand-title">Classic Motors KE</h1>
            <p className="footer_text">
              Classic Motors KE is a premier car dealership in Mombasa
              specializing in new, foreign, and locally used vehicles. With our
              import-on-behalf service and 100% delivery record, we make car
              ownership accessible and hassle-free. Visit us in Westlands or
              call today to find your dream car.
            </p>
            <div className="footer-keywords" aria-hidden="true">
              <span>Car Dealer Mombasa</span>
              <span>Used Cars Kenya</span>
              <span>New Cars Kenya</span>
              <span>Import Cars Kenya</span>
              <span>Trusted Car Dealer</span>
            </div>
          </div>

          <div className="col-lg-4 px-lg-5 mb-4 mb-lg-0">
            <h2 className="footer_title">Contact Us</h2>
            <address className="footer_text">
              <p>
                <strong>Phone 1:</strong>{" "}
                <a href="tel:+254707308556">07 07 308 556</a>
              </p>
              <p>
                <strong>Phone 2:</strong>{" "}
                <a href="tel:+254707308556">07 25 219 171</a>
              </p>

              <p>
                <strong>Email:</strong>{" "}
                <a href="mailto:info@classicmotorske.com">
                  info@classicmotorske.com
                </a>
              </p>
              <p>
                <strong>Location:</strong> Mombasa, Moi Avenue, opp KCB Bank
                Kilindini
              </p>
              <p>
                <strong>Business Hours:</strong> Mon-Sat: 8:00 AM - 6:00 PM
              </p>
            </address>
          </div>

          <div className="col-lg-3 mb-4 mb-lg-0">
            <h2 className="footer_title">Quick Links</h2>
            <ul className="footer-links">
              <li>
                <a href="/inventory" aria-label="View our car inventory">
                  Inventory
                </a>
              </li>
              <li>
                <a href="/about" aria-label="About Classic Motors KE">
                  About Us
                </a>
              </li>
              <li>
                <a href="/services" aria-label="Our car dealership services">
                  Services
                </a>
              </li>
              <li>
                <a href="/financing" aria-label="Car financing options">
                  Financing
                </a>
              </li>
              <li>
                <a href="/testimonials" aria-label="Customer testimonials">
                  Testimonials
                </a>
              </li>
              <li>
                <a href="/blog" aria-label="Car buying tips and news">
                  Blog
                </a>
              </li>
            </ul>

            <h2 className="footer_title mt-4">Follow Us</h2>
            <div className="footer_social_media">
              <a
                href="https://www.facebook.com/classicmotorske"
                className="social-icon"
                aria-label="Classic Motors KE on Facebook"
                rel="noopener noreferrer"
              >
                <FaFacebook size={25} />
              </a>
              <a
                href="https://twitter.com/classicmotorske"
                className="social-icon"
                aria-label="Classic Motors KE on Twitter"
                rel="noopener noreferrer"
              >
                <FaTwitter size={25} />
              </a>
              <a
                href="https://www.instagram.com/classicmotorske"
                className="social-icon"
                aria-label="Classic Motors KE on Instagram"
                rel="noopener noreferrer"
              >
                <FaInstagram size={25} />
              </a>
              <a
                href="https://www.youtube.com/classicmotorske"
                className="social-icon"
                aria-label="Classic Motors KE on YouTube"
                rel="noopener noreferrer"
              >
                <FaYoutube size={25} />
              </a>
            </div>
          </div>

          <div className="col-12 footer_credits text-center">
            <p>
              © {new Date().getFullYear()} <strong>Classic Motors KE</strong>.
              All Rights Reserved. |
              <a href="/privacy-policy" aria-label="Privacy Policy">
                {" "}
                Privacy Policy
              </a>{" "}
              |
              <a href="/terms" aria-label="Terms of Service">
                {" "}
                Terms of Service
              </a>{" "}
              |
              <a href="/sitemap.xml" aria-label="Sitemap">
                {" "}
                Sitemap
              </a>
            </p>
            <p
              className="schema-markup"
              itemScope
              itemType="https://schema.org/AutoDealer"
            >
              <meta itemProp="name" content="Classic Motors KE" />
              <meta itemProp="telephone" content="+254707308556" />
              <meta
                itemProp="address"
                content="Westlands, Waiyaki Way, Mombasa, Kenya"
              />
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
